import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { DemoService } from './../../../../demo.service';
import { FileUploaderService } from './../../../../services/file-uploader-service';
import { GlobalFunctionsService } from './../../../../services/global-functions.service';
import { MysqlService } from './../../../../services/mysql.service';
import { JobSubject } from './../../../../shared/models/jobSubject.model';

// import { HotToastService } from '@ngneat/hot-toast';
import { BsModalService } from 'ngx-bootstrap';
import { HotToastComponent } from '@ngneat/hot-toast/lib/components/hot-toast/hot-toast.component';
import { HotToastModule, HotToastService } from '@ngneat/hot-toast';
import { DataUtil } from '@syncfusion/ej2-data';

@Component({
  selector: 'app-subject-card',
  templateUrl: './subject-card.component.html',
  styleUrls: ['./subject-card.component.css']
})
export class SubjectCardComponent implements OnInit {
  sessionUserId: any;
  nav: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  subject_id: number;
  subject: any;
  job_id: any;
  file_number: any;
  subject_number: any;
  job_type_id: any;
  job_type_location_id: any;
  job_type_court_id: any;
  job_type_document_type_id: any;
  job_type_affidavit_type_id: any;
  model: JobSubject;
  subject_progress: any;
  DialogObj: any;
  allAgents: any;
  assignedAgentsList: any;
  agent_associated: number;
  count_subject_progress: any;
  job_subjects: any;
  job_subjects_count: any;
  metrics_stage_subjects: any[] = [];

  constructor(
    private _demoService: DemoService,
    private route: ActivatedRoute,
     vcr: ViewContainerRef, private router: Router,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public gfunc: GlobalFunctionsService,
     public toastr: HotToastService,
  ) {

    this.nav = document.querySelector('nav.navbar');
    // this.toastr.setRootViewContainerRef(vcr);

  // login vars
// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

     // need to add this as routes does not work globally
     this.all_router_details = this.router.url;
     this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

  this.subject_id = +this.route.snapshot.paramMap.get('subject_id');

 

   }

  ngOnInit() {

    if (this.gfunc.sessionUserLevel == 5){
      this.getSubjectAgentBrandsAssigned(this.subject_id);
      }


    this.model = new JobSubject;
    this.getJobSubject(this.subject_id);

  }

  get metricsStageSubjects(): any[] {
    return this.metrics_stage_subjects;
  }

  private refreshMetricsStageSubjects(): void {
    const explicitStageSubjects = Array.isArray(this.subject_progress)
      ? this.subject_progress.filter((item) => !!item)
      : [];

    if (explicitStageSubjects.length > 1) {
      this.metrics_stage_subjects = explicitStageSubjects;
      return;
    }

    const jobSubjects = Array.isArray(this.job_subjects)
      ? this.job_subjects.filter((item) => !!item)
      : [];

    if (!jobSubjects.length) {
      this.metrics_stage_subjects = explicitStageSubjects;
      return;
    }

    const linkedStageSubjects = this.resolveLinkedStageSubjects(jobSubjects, this.toNumericId(this.subject_id));
    if (linkedStageSubjects.length > 1) {
      this.metrics_stage_subjects = linkedStageSubjects;
      return;
    }

    const currentFileNumber = `${this.file_number ?? ''}`.trim();
    if (currentFileNumber) {
      const matchingFileSubjects = jobSubjects.filter((item) => `${item?.file_number ?? ''}`.trim() === currentFileNumber);
      if (matchingFileSubjects.length > 1) {
        this.metrics_stage_subjects = matchingFileSubjects;
        return;
      }
    }

    this.metrics_stage_subjects = explicitStageSubjects;
  }




  getJobSubject(subject_id) {
    this._demoService.getJobSubject(subject_id).subscribe(
       data => { this.subject = data;
        const res = data[0];
        this.model = res;

        this.job_id = res.job_id;
        this.file_number = res.file_number;
        this.subject_number = res.subject_number;

        this.job_type_id = res.job_type_id;
        this.job_type_location_id = res.job_type_location_id;
        this.job_type_court_id = res.job_type_court_id;
        this.job_type_document_type_id = res.job_type_document_type_id;
        this.job_type_affidavit_type_id = res.job_type_affidavit_type_id;

// count existing subjects validate for edit or not.
this.getJobsTableDataSubjects(this.job_id);

//:: test to load these after the data is returned true or false;

            //   // this.getSubjectNotes(res.subject_id);
            //   // load subject history
              this.getSubjectProgress(this.job_id, this.file_number);

            // // get job type in relation to subject
            //  this.getJobType(this.job_type_id);
            //  this.getJobTypeLocation(this.job_type_location_id);
            //  this.getJobTypeCourt(this.job_type_court_id);
            //  this.getJobTypeDocument(this.job_type_document_type_id);
            //  this.getJobTypeAffidavit(this.job_type_affidavit_type_id);

            //  this.getJobSubjects(this.job_id); // total subjects of job count to hide delete if one left.

// this.getSubjectNotesProgressionTable(res.job_id, res.file_number, this.model )
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );

   } // end function




   getSubjectProgress(job_id, file_number){
    this._demoService.getSubjectProgress(job_id, file_number).subscribe(
      data => { this.subject_progress = data;
        let res = data[0];
        

        this.count_subject_progress = this.subject_progress.length
        this.refreshMetricsStageSubjects();

        // this.load_me_last = 1;
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
    }



    // custom dialog

public onOpenDialogNewStage = function(event: any, filename, model): void {
  this.DialogObj = DialogUtility.confirm({
  title: 'Create New Subject Stage',
  content: 'Create a new subject stage from this existing subject details',
  okButton: { text: 'Generate New Subject', click: this.okNewStageClick.bind(this, filename, model) },
  cancelButton: {  text: 'Cancel', click: this.cancelNewStageClick.bind(this) },
  showCloseIcon: true,
  closeOnEscape: true,
  animationSettings: { effect: 'Zoom' }
});
}
public okNewStageClick(this, filename, model): void {
//  alert('you clicked OK button');
// run save file option
// this.saveBothTemplate(filename, model);
console.log('SubjectID: ' + model.subject_id);
this.newSubjectReference(model);
this.DialogObj.hide();
}

public cancelNewStageClick(): void {
// alert('you clicked Cancel button');
this.DialogObj.hide();
};

  private resolveLinkedStageSubjects(subjects: any[], subjectId: number | null): any[] {
    if (!subjectId || !Array.isArray(subjects) || !subjects.length) {
      return [];
    }

    const byId = new Map<number, any>();
    for (const subject of subjects) {
      const currentId = this.toNumericId(subject?.subject_id);
      if (currentId) {
        byId.set(currentId, subject);
      }
    }

    let first = byId.get(subjectId);
    if (!first) {
      return [];
    }

    const walkedBack = new Set<number>([subjectId]);
    while (first) {
      const previousId = this.toNumericId(first?.prev_subject_id);
      if (!previousId || walkedBack.has(previousId) || !byId.has(previousId)) {
        break;
      }

      walkedBack.add(previousId);
      first = byId.get(previousId);
    }

    const chain: any[] = [];
    const emitted = new Set<number>();
    let current = first;

    while (current) {
      const currentId = this.toNumericId(current?.subject_id);
      if (!currentId || emitted.has(currentId)) {
        break;
      }

      chain.push(current);
      emitted.add(currentId);

      const nextId = this.toNumericId(current?.next_subject_id);
      if (!nextId || emitted.has(nextId) || !byId.has(nextId)) {
        break;
      }

      current = byId.get(nextId);
    }

    return emitted.has(subjectId) ? chain : [];
  }

  private toNumericId(value: any): number | null {
    const numericValue = Number(value);
    return Number.isFinite(numericValue) && numericValue > 0 ? numericValue : null;
  }



// Mussing Function


// this reports as failes but actually works.

newSubjectReference(model){
  this._demoService.newSubjectReference(model).subscribe(
    data => { // this.new_subject_data = data; // this is the retuned json upon creation.
    this.toastr.success('New Subject Reference Data Entered');
    // API Updated to return JSON of last inserted ID: {"last_insert_id" : "232"}

     // Setup annd the Currents before we redirec the page
     // Needs to be a Function to update the ObserveOnOperator.
     // this.newCTrace_id(this.latest_trace_id);
     // or this.cdata.changeCTrace_id("999");

   // this.router.navigate(['/admin/jobs/view/' + model.job_id + '']);

      if(model.job_status == 'CLOSED'){
        this.gfunc.insertLog_UpdateSubjectNewStageFromClosed(model); 
      }else{
        this.gfunc.insertLog_UpdateSubjectNewStage(model); 
      }


      // Need to split this function to state if from closed or just creating a new subject stage, by _status is closed or not... as per button press functions...
      // Log type id == 15 + 79 for open from closed new stage and new subject stage from closed.
      // This function probably is located in many places so I will beed to look at this throughout the site...... // and do both for fail and succeed by the looks

    // this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
    // this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));
    this.gfunc.globalJobSubjectViewSkipRoute(model.subject_id);
       return true;


    },
    error => {
    // console.log('Should be form Model' + model);
    // console.error('Error Creating a Trace Project!');
   //  this.toastr.error('Adding Subject Reference Failed :: Please try again!');
   // this.router.navigate(['/admin/jobs/view/' + model.job_id + '']);
  //  this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
  //  this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));


  // if(model.job_status == 'CLOSED'){
  //   this.gfunc.insertLog_UpdateSubjectNewStageFromClosed(model); 
  // }else{
  //   this.gfunc.insertLog_UpdateSubjectNewStage(model); 
  // }

    this.gfunc.globalJobSubjectViewSkipRoute(model.subject_id);
     // console.log(Observable.throw(error));
     // return Observable.throw(error);
    }
);


};



// need to get all associated agents of the job and push thier information to array
getSubjectAgentBrandsAssigned(subject_id) {
  console.log('Running Subject Agent Access Checker!!! 101');
    this.allAgents = [];
    this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
       data => { 
         this.assignedAgentsList = data;
        //  let res = data[0];
         let newArr = data;
         let  count_of_items = Object.keys(newArr).length;
           // need to do a loop of subject_billing items (.length)
           this.agent_associated = 0;
  
           let array = [];
           let ata_array = [];
           let array_length;
  
           for(let i=0;i < count_of_items; i++) {
           let res = newArr[i];
  
           this.allAgents.push({
             recipient_name: res.name + '',
             recipient_email_address: res.email,
             recipient_brand_id: res.brand_id,
             recipient_subject_id: res.subject_id,
             recipient_brand_type_id: res.brand_type_id,
             recipient_user_id: null,
             recipient_user_level_id: null,
             recipient_type_name: 'Agent',
           });
           } // end for loop
        //  this.allAgents = this.allAgents; // ?? this may be causing errors.
         // set records to send to subject_notes data table
        //  this.model.assigned_to_agents = JSON.stringify(this.allRecipients);
  
              // array = res.assigned_to_agents;
    array = JSON.parse(this.allAgents);
    // console.log('array: ', array);
        
    ata_array = array.filter( (n: any) => (
            n.recipient_brand_id === this.gfunc.sessionBrandId
            // n.note_id >= '200'
            // && sbi.subject_id === this.subject_service_metrix_search_full_results[i].subject_id
            ));
            console.log('ata_array.lenght: ', ata_array.length);
           
           // does the check and decides if to display page or note
            array_length = ata_array.length;
            if (ata_array.length >= 1) {
              this.agent_associated = 1;
            };
            
            if (ata_array.length === 0) {
             this.agent_associated = 0;
            }
            // console.log('Agent Associated: ', this.agent_associated);
  
      },
       err => console.error(err),
       // () => console.log('Loaded Assigned Agents Loaded.')
     );
   }




  getJobsTableDataSubjects(job_id) {
    this._demoService.getJobsTableDataSubjects(job_id).subscribe(
      data => {
        this.job_subjects = data;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.job_subjects = DataUtil.parse.parseJson(data);

        this.job_subjects_count = this.job_subjects.length;
        this.refreshMetricsStageSubjects();
//         this.job_subjects_not_closed_count = this.subjects_urgent.filter((item) => item.job_status !== 'CLOSED')
//         .map((item) => +item.invoice_id).length;


//         // using loadsash to group
//    this.job_subjects_grouped = _.groupBy(
//   this.subjects_urgent.filter(item => item.job_status !== 'CLOSED'),
//   'file_number'
// );

        // console.log("Done loadng USER");
        // console.log(this.users);


      },
      error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
      }
    );
  }
   


}
